import React from 'react'
import PropTypes from 'prop-types'
import { MyTimesheet } from './my-timesheet'
import { TimesheetStatus } from './timesheet-status'
import { TimesheetApproval } from './timesheet-approval'

export const Statusbar = (props) => {
  switch (props.activeTab) {
    case 1:
      return <MyTimesheet { ...props } />
    case 3:
      return <TimesheetStatus { ...props } />
    case 4:
      return <TimesheetApproval { ...props } />
    default:
      return null
  }
}

Statusbar.propTypes = {
  activeTab: PropTypes.number.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/timesheet/status-bar/index.js